import { render, staticRenderFns } from "./SelectLoyaltyReward.vue?vue&type=template&id=29d80926&scoped=true&"
import script from "./SelectLoyaltyReward.vue?vue&type=script&lang=ts&"
export * from "./SelectLoyaltyReward.vue?vue&type=script&lang=ts&"
import style0 from "./SelectLoyaltyReward.vue?vue&type=style&index=0&id=29d80926&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d80926",
  null
  
)

export default component.exports